import * as React from 'react'
import PowerSelect from '../../Form/PowerSelect'
import styled from 'styled-components'
import { Style } from '../../../styles'
import { WithTranslation, withTranslation } from 'react-i18next'
import ReactSelectTheme from '../../Form/ReactSelectTheme'
import { MollieFormData, MollieIntegrationConfig } from '../../../types'

type IProps = {
  config: MollieIntegrationConfig
  formData: MollieFormData
  onConfigChange: (config: MollieIntegrationConfig) => void
} & WithTranslation

interface IState { }

const Container = styled.div`
	display: flex;
	flex-direction: column;

	h1 {
		color: white;
		margin-bottom: ${Style.spacing.x2};
    font-weight: bold;
	}
	
	label {
		color: white;
	}
`

class MollieForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.onProfileIdChange = this.onProfileIdChange.bind(this)
  }

  onProfileIdChange(option) {
    const { config, onConfigChange } = this.props

    onConfigChange({
      ...config,
      profile_id: option.value,
    })
  }

  render() {
    const { config, formData, t } = this.props
    const { profiles } = formData

    const profileOptions = profiles
    const selectedProfileOption = profiles.find(p => p.value === config.profile_id)

    return (
      <Container>
        <h1>{t('MollieForm::Settings')}</h1>
        <div className='form-item'>
          <label>
            {t('MollieForm::Choose the profile you want to receive payments on.')}
          </label>
          <PowerSelect
            options={profileOptions}
            value={selectedProfileOption}
            onChange={this.onProfileIdChange}
            theme={ReactSelectTheme}
          />
        </div>
      </Container>
    )
  }
}

export default withTranslation()(MollieForm)